import angular from 'angular';
import moment from 'angular-moment';
import DateUtil from "../../../../components/logic/date_util/date_util.module";
import PowerFormatter from "../../../../components/logic/power-formatter/power-formatter.logic";
import DailyMaxDemandPowerService from "../../../../components/api/daily_max_demand_power/daily_max_demand_power.service";

import chartConfig from './compare-graph-monthly.config';

export class CompareGraphMonthlyDemandController {
  /*@ngInject*/
  constructor($filter, $scope, $q, moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService) {
    this.$filter = $filter;
    this.moment = moment;
    this.$q = $q;
    this.DailyMaxDemandPowerService = DailyMaxDemandPowerService;
    this.PowerFormatter = PowerFormatter;
    this.DateUtil = DateUtil;

    this.today = new Date();
    this.maxDate = this.moment().startOf('day').toDate();
    this.categories = [];
    this.graphUpdating = false;

    this.chartConfig = chartConfig(this);

    $scope.$watch('$ctrl.selectedConfigs', () => this.updateGraph(this.targetDate));
    $scope.$watch('$ctrl.targetDate', () => this.updateGraph(this.targetDate));
  }

  $onInit() {}

  changeMonth(diff) {
    this.updateTargetDate({targetDate: this.DateUtil.leapMonth(this.targetDate, diff)});
  }

  updateGraph(date) {
    const targetDate = this.moment(date);
    this.startDate = targetDate.clone().startOf('month').toDate();
    this.endDate = targetDate.clone().endOf('month').toDate();

    if (this.chart) {
      this.chart.reflow();
    }
    if (this.selectedConfigs.length === 0) {
      return;
    }
    this.graphUpdating = true;
    this.resetSeries();

    const numberOfDays = (this.endDate - this.startDate) / (24 * 60 * 60 * 1000);
    this.categories = [];
    let startUtc = this.DateUtil.localToUTC(this.startDate);
    for (let i = 0; i <= numberOfDays; i++) {
      this.categories.push(this.DateUtil.leapDate(startUtc, i).valueOf());
    }
    this.chart.xAxis[0].setCategories(this.categories);

    const promises = [];
    for (let config of this.selectedConfigs) {
      promises.push(this.getDemandData(config, this.categories, this.startDate, this.endDate));
    }

    this.$q.all(promises).then(results => {
      for (let result of results) {
        this.addSeries(result.powers, result.config);
      }
      this.chart.redraw();
      this.chart.reflow();
      this.graphUpdating = false;
    });
  }

  getDemandData(config, categories, startDate, endDate) {
    const dateQuery = this.DateUtil.getDateRangeQueries(startDate, endDate);
    const query = angular.extend({id: config.id}, dateQuery);

    return new Promise(resolve => {
      this.DailyMaxDemandPowerService.show(query, res => {
        const powers = this.PowerFormatter.formatDailyDemandPowers(res.powers, categories);
        resolve({powers, config});
      });
    });
  }

  addSeries(powers, config) {
    if (!powers) {
      return;
    }
    const graphData = this.categories.map((e, i) => {
      const label = this.moment(e).format('MM/DD');
      return [label, powers[i].y];
    });
    this.chart.addSeries({
      name: config.pms_service_code,
      type: this.graphType,
      data: graphData
    }, false);
  }

  resetSeries() {
    if (!this.chart) {
      return;
    }
    while (this.chart.series.length > 0) {
      this.chart.series[0].remove(false);
    }
  }
}

export default angular.module('leptonApp.compareGraphMonthlyDemand', [moment, DateUtil, PowerFormatter, DailyMaxDemandPowerService])
  .component('compareGraphMonthlyDemand', {
    template: require('./compare-graph-monthly.html'),
    controller: CompareGraphMonthlyDemandController,
    bindings: {
      selectedConfigs: '=',
      configIds: '=',
      graphType: '=',
      targetDate: '=',
      updateTargetDate: '&'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/demand/monthly/compare-graph-monthly.component.js